<template>
  <div>
    <b-modal
      id="review-abandon-meeting-modal"
      size="lg"
      centered
      body-class="modal-body-scrollable"
      @shown="fetchRaces"
    >
      <!-- HEADER -->
      <template #modal-header>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <feather-icon
              size="22"
              icon="AlertTriangleIcon"
              class="text-danger mr-1"
            />
            <h4 class="mb-0 text-danger">Races to be Abandoned</h4>
          </div>

          <b-button variant="link" class="p-0" @click="closeModal">
            <feather-icon icon="XIcon" size="20" class="text-muted" />
          </b-button>
        </div>
      </template>

      <!-- SUBTITLE -->
      <p class="text-muted small">
        The following 10 bets will be cancelled and refunded.
      </p>

      <!-- SUMMARY BOX -->
      <b-card
        style="
          background: #dbeafe;
          border: 1px solid #93c5fd;
          border-radius: 6px;
        "
      >
        <b-row class="text-center">
          <b-col cols="3">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              {{ items.length }} Races
            </h4>
            <span style="color: #1e40af">to be abandoned</span>
          </b-col>
          <b-col cols="3">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              182 Bets
            </h4>
            <span style="color: #1e40af">to be cancelled</span>
          </b-col>

          <b-col cols="3">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              {{ formatCurrencyBuiltInFunc(48700) }}
            </h4>
            <span style="color: #1e40af">to be refunded</span>
          </b-col>

          <b-col cols="3">
            <h4 class="font-weight-bold mb-0" style="color: #1e40af">
              {{ formatCurrencyBuiltInFunc(240700) }}
            </h4>
            <span style="color: #1e40af">liability released</span>
          </b-col>
        </b-row>
      </b-card>

      <b-table
        :items="items"
        :fields="fields"
        small
        responsive="sm"
        :busy="loadingRaces"
      >
        <template #cell(race)="{ item }">
          <span> R{{ item.eventNo }} </span>
        </template>
        <template #cell(name)="{ item }">
          <span>
            {{ item.eventName }}
          </span>
        </template>
        <template #cell(status)="{ item }">
          <b-badge :variant="statusColor(item.finalStatus)">
            {{ item.finalStatus }}
          </b-badge>
        </template>
        <template #cell(time)="{ item }">
          <span>
            {{ format(new Date(item.scheduledUtcTime), "hh:mm") }}
          </span>
        </template>
        <template #cell(runners)="{ item }">
          <span>
            {{ item.totalRunner }}
          </span>
        </template>
        <template #cell(activeBets)="{ item }">
          <span> {{ item.activeBets || 0 }} bets </span>
        </template>
        <template #cell(liability)="{ item }">
          <span>
            {{ formatCurrencyBuiltInFunc(item.liability) || "-" }}
          </span>
        </template>

        <template #cell(stakes)="{ item }">
          <span>
            {{ formatCurrencyBuiltInFunc(item.stakes) || "-" }}
          </span>
        </template>
        <template #cell(action)="{ item }">
          <b-button
            v-if="item.finalStatus !== 'FINAL' && item.finalStatus !== 'ABANDONED'"
            size="sm"
            variant="danger"
            @click="confirmAbandonRace(item.raceId)"
          >
            Abandon
          </b-button>
          <span v-else class="text-muted">Completed</span>
        </template>
      </b-table>

      <!-- FOOTER BUTTONS -->
      <template #modal-footer>
        <div class="d-flex justify-content-end align-items-center">
          <b-button variant="secondary" class="mr-1" @click="closeModal"
            >Cancel</b-button
          >
          <b-button
            variant="danger"
            @click="confirmAbandonMeeting"
            :loading="loadingAbandon"
            >Confirm Abandon Meeting</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  BRow,
  BCol,
  BTable,
  BBadge,
  BCard,
} from "bootstrap-vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapState, mapActions } from "vuex";
import { format } from "date-fns";
export default {
  components: {
    BButton,
    BModal,
    BRow,
    BCol,
    BTable,
    BCard,
    BBadge,
  },

  data() {
    return {
      items: [],
      fields: [
        { key: "race", label: "Race" },
        { key: "time", label: "Time" },
        { key: "name", label: "Event Name" },
        { key: "runners", label: "Runners" },
        { key: "status", label: "Status" },
        { key: "activeBets", label: "Active Bets" },
        { key: "stakes", label: "Stakes" },
        { key: "liability", label: "Liability" },
        { key: "action", label: "Action" },
      ],
    };
  },
  computed: {
    ...mapState("trading/racing", ["loadingAbandon", "loadingRaces"]),
  },
  methods: {
    ...mapActions("trading/racing", {
      abandonMeeting: "abandonMeeting",
      abandonRace: "updateRaceDetail",
      getRacesOfMeeting: "getRacesOfMeeting",
    }),
    closeModal() {
      this.$bvModal.hide("review-abandon-meeting-modal");
    },
    async confirmAbandonMeeting() {
      const meetingId = this.$route.params.id;
      if (!meetingId) return;
      const result = await this.abandonMeeting(meetingId);
      if (result) {
        this.closeModal();
        this.$emit("onFetchRaces");
      }
    },
    async confirmAbandonRace(raceId) {
      if (!raceId) return;
      const result = await this.abandonRace({
        raceId,
        finalStatus: "ABANDONED",
      });
      if (result) {
        this.items = this.items.map((item) =>
          item.raceId === raceId ? { ...item, finalStatus: "ABANDONED" } : item
        );
        this.$emit("onFetchRaces");
      }
    },
    async fetchRaces() {
      const data = await this.getRacesOfMeeting({
        meetingId: this.$route.params.id,
      });
      this.items = data;
    },
    format,
    formatCurrencyBuiltInFunc,
    statusColor(status) {
      switch (status) {
        case "FINAL":
          return "success";
        case "UPCOMING":
          return "warning";
        case "OPEN":
          return "primary";
        case "ABANDONED":
          return "danger";
        default:
          return "secondary";
      }
    },
  },
};
</script>
<style>
.modal-body-scrollable {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
